import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, Renderer2, ChangeDetectorRef, NgZone } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { v_InvoiceNoteBus } from '@app/cp/shared/models/v_InvoiceNoteBus';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InvoiceService } from '@app/cp/shared/services/invoice.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { InvoiceNoteBus } from '@app/cp/shared/models/InvoiceNoteBus';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { BaseGridEditFormLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-formlines.component';
import { Subscription } from 'rxjs/internal/Subscription';
import { fromEvent, Subject } from 'rxjs';
import { tap, take, takeUntil } from 'rxjs/operators';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { DateFunctions } from '../../shared/static/date-functions';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
  selector: 'invoice-notes',
  templateUrl: './invoice-notes.component.html',
  styleUrls: ['./invoice-notes.component.scss']
})
export class InvoiceNotesComponent extends BaseGridEditFormLinesComponent<v_InvoiceNoteBus, null, InvoiceService> { // CPWorkOrderDetailComponent>  {
    @Output() showDispatch: EventEmitter<any> = new EventEmitter<any>();
    @Input() ShowDispatchPopup: boolean = false;
    @Output() showQuote: EventEmitter<any> = new EventEmitter<any>();
    @Input() ShowQuotePopup: boolean = false;
    private insertMode: boolean = false;
    private destroy$ = new Subject();
    private currentSubscription: Subscription;
    rowLine: number;
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: InvoiceService, private zone: NgZone, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "v_InvoiceNoteBus";
        this.appCode = "InvoiceNotes";
        this.appName = "Invoice Notes"
        this.callSaveIndividualInsteadOfSave = true;
        this.disableCpSearchDialog();
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'invoiceNoteId': new UntypedFormControl(),
            'invoiceId': new UntypedFormControl(),
            'invoiceNotes': new UntypedFormControl(),
            'invoiceNotePersonId': new UntypedFormControl(),
            'isPrintable': new UntypedFormControl(),
            'sortOrder': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'personName': new UntypedFormControl()

        });
    }
    setForm() {
        this.editForm.patchValue({
            invoiceNoteId: this.selectedData.invoiceNoteId,
            invoiceId: this.selectedData.invoiceId,
            invoiceNotes: this.selectedData.invoiceNotes,
            invoiceNotePersonId: this.selectedData.invoiceNotePersonId,
            isPrintable: this.selectedData.isPrintable,
            sortOrder: this.selectedData.sortOrder,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            personName: this.selectedData.personName
        });
        this.notes = CommonFunctions.getStringValueIfNull(this.selectedData.invoiceNotes);
    }
    createNewSaveVersion(className: string, data: any = null): any {
        let busObj: InvoiceNoteBus = super.createNewSaveVersion(className, data);
        busObj.setAdditionalFromView(data);
        if (!CommonFunctions.hasGuidValue(busObj.invoiceNotePersonId) && busObj.invoiceNotePersonId != CommonValues.Guid_Empty) {
            busObj.invoiceNotePersonId = this.globals.personId; // busObj.updateUserId;
        }
        busObj.setBeforeSave();
        return busObj;
    }
    setFromReferenceData(data: v_InvoiceNoteBus) {
        data.personName = this.personName(data.invoiceNotePersonId);
        return data;
    }
    setFromNonFormData(data: v_InvoiceNoteBus) {
        data.invoiceNotes = this.notes;
        return data;
    }
    notesPersonId(dataItem: v_InvoiceNoteBus = null): any {
        dataItem = !dataItem ? this.selectedData : dataItem;
        return dataItem ? dataItem.invoiceNotePersonId : null;
    }
    protected getChangedObject(data: v_InvoiceNoteBus) {
        return this.createNewSaveVersion("InvoiceNoteBus", data);
    }
    //protected save(dataObj: v_InvoiceNoteBus) {
    //    let busObj: InvoiceNoteBus = this.createNewSaveVersion("InvoiceNoteBus", dataObj);

    //    this.svc_data.saveInvoiceNote(busObj).subscribe((info: BaseMessageInfo) => {
    //        if (!info.saveError) {
    //            let retData: InvoiceNoteBus = info.primaryReturn as InvoiceNoteBus;
    //            let newDataObj: v_InvoiceNoteBus = new v_InvoiceNoteBus(info.primaryReturn);
    //           /// if (busObj.isAdded) {
    //                newDataObj.insertDt = dataObj.insertDt;
    //           // }
    //            newDataObj.invoiceNotes = retData.invoiceNotes1;
    //            this.saveSuccess(newDataObj);
    //        }
    //        else {
    //            this.saveError(dataObj, info.message);
    //        }
    //    });
    //}

    saveIndividual(dataObj: v_InvoiceNoteBus): Promise<BaseMessageInfo> {
        let busObj: InvoiceNoteBus = this.createNewSaveVersion("InvoiceNoteBus", dataObj);
        var isAdded = busObj.isAdded;

        let retInfo: BaseMessageInfo = new BaseMessageInfo();
        return new Promise((resolve, reject) => {
            this.svc_data.saveInvoiceNote(busObj).toPromise().then((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let retData: InvoiceNoteBus = info.primaryReturn as InvoiceNoteBus;
                    retData.insertDt = DateFunctions.getISOStringWithoutMilliseconds(retData.insertDt);
                    let newDataObj: v_InvoiceNoteBus = new v_InvoiceNoteBus(info.primaryReturn);
                    newDataObj = this.setFromReferenceData(newDataObj);
                    newDataObj.invoiceNotes = retData.invoiceNotes1;
                    retInfo.primaryReturn = newDataObj;
                    this.notify(this.appCode + " Saved Successfully!");
                } else {
                    retInfo.message = "Error Saving"
                    retInfo.saveError = true;
                    this.saveError(null, retInfo.message);
                }
                this.dataLoading = false;
                //if (this.GridEditMode == 1) {
                //    this.doParentAction(this.parentId, "GETPAGEDATA", "DISPATCHNOTES");
                //}
                resolve(retInfo);
            });
        });
    }

    deleteIndividual(data: v_InvoiceNoteBus) {
        this.svc_data.deleteNote(data.invoiceNoteId).subscribe((retData: BaseMessageInfo) => {
            if (retData.saveError) {
                this.notify(CommonValues.Message_ErrorDeleting + " - " + retData.message, 'E');
            }
            else {
                this.removeLocal(data);
                this.notify(CommonValues.Message_SuccessfullyDeleted);

            }
        });

    }
    customCheckBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "isPrintable") {
            this.editForm.patchValue({
                isPrintable: e.target.checked
            });

        }

    }
    get canEditNote(): boolean {
        let can: boolean = false;

        if (this.canEdit && this.selectedData ) {
            if (this.selectedData.invoiceNotePersonId == this.globals.personId || this.rights.EditOthersNotes) {
                can = true;
            }
        }

        return can;
    }
    get canSaveNote(): boolean {
        let can: boolean = false;

        if (this.canSave && this.notes.length > 0) {
            can = true;
        }

        return can;
    }

    canDeleteNote(dataItem: v_InvoiceNoteBus): boolean {
        let can: boolean = false;

        if (this.canEdit && dataItem) {
            if (dataItem.invoiceNotePersonId == this.globals.personId || this.rights.EditOthersNotes) {
                can = true;
            }
        }

        return can;
    }

    test() {
        console.log("inv-notes->test: ", this.saveMode, this);
    }
    rowClassFunction(context: RowClassArgs) {
        if (context.dataItem.isDraged) {
            return { isDraged: true }
        }
    }
    popupDispatch() {

        this.showDispatch.emit(null);
    }
    popupQuote() {

        this.showQuote.emit(null);
    }
    ngOnDestroy(): void {
        CommonFunctions.unsubscribe(this.currentSubscription);
    }
    tableRow = node => node.tagName.toLowerCase() === 'tr';
    closest = (node, predicate) => {
        while (node && !predicate(node)) {
            node = node.parentNode;
        }

        return node;
    };
    processGridData() {

        this.getDragReady();
    }
    getDragReady() {

        if (this.currentSubscription) {
            var subs = this.currentSubscription;
            if (this.destroy$) {
                this.destroy$.next('TODO: BILL LOOK AT THIS');
                this.destroy$.complete();
            }
            this.destroy$ = new Subject();
            this.currentSubscription.unsubscribe();
        }
      //  if (this.canDrag) {
            this.zone.onStable.pipe(take(1))
                .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
       // }
    }

    handleDragAndDrop(): Subscription {

        const sub = new Subscription(() => { });

        let draggedItemIndex;
        let dropItemIndex;
        let remoteDropItemIndex;
        let droplocation;
        let overCnt: number = 0;
        let me = this;
        var inEditMode = "true";
        if (this.editForm) { inEditMode = "false"; }
        const tableRows = Array.from(document.querySelectorAll('div.invoiceNoteGridDiv > .k-grid tr'));
        tableRows.forEach(itemRow => {
            var item = itemRow.children[0];
            if (item.localName == 'td' && item.childNodes.length > 2) {
                this.renderer.setAttribute(itemRow, 'draggable', inEditMode);
                const dragStart = fromEvent<DragEvent>(itemRow, 'dragstart');
                const dragOver = fromEvent(itemRow, 'dragover');
                const dragEnd = fromEvent(itemRow, 'dragend');
                const dragLeave = fromEvent(itemRow, 'dragleave');

                sub.add(dragStart.pipe(takeUntil(this.destroy$)).pipe(
                    tap(({ dataTransfer }) => {
                        try {
                            //const dragImgEl = document.createElement('span');

                            //const dragImgEl2 = document.createElement('i');
                            //dragImgEl2.classList.add('fas fa-arrows-alt');
                            //dragImgEl.setAttribute('style', 'position: absolute; display: block; top: 0; left: 0; width: 0; height: 0;');
                            //document.body.appendChild(dragImgEl);
                            //dataTransfer.setDragImage(dragImgEl2, 0, 0);
                        } catch (err) {
                            // IE doesn't support setDragImage
                        }
                        try {
                            // Firefox won't drag without setting data
                            //dataTransfer.setData('application/json', {});
                        } catch (err) {
                            // IE doesn't support MIME types in setData
                        }
                    })
                ).pipe(takeUntil(this.destroy$)).subscribe(({ target }) => {

                    const cell: HTMLTableCellElement = <HTMLTableCellElement>target
                    const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                    draggedItemIndex = row.rowIndex;
                    const dataItem = this.gridData[draggedItemIndex];

                }));
                sub.add(dragLeave.pipe(takeUntil(this.destroy$)).pipe(takeUntil(this.destroy$)).subscribe((e: any) => {

                    const cell: HTMLTableCellElement = <HTMLTableCellElement>e.target
                    const row: HTMLTableRowElement = <HTMLTableRowElement>cell.parentElement;
                    const row2: HTMLTableRowElement = <HTMLTableRowElement>row.parentElement;
                    const row3: HTMLTableRowElement = <HTMLTableRowElement>row2.parentElement;
                    const dropIndex = this.closest(row, this.tableRow).rowIndex;
                    if (remoteDropItemIndex == dropIndex) {
                        remoteDropItemIndex = null;

                        me.rowLine = null;
                    }
                    if (dropItemIndex == dropIndex) { dropItemIndex = null; }

                }));

                sub.add(dragOver.pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
                    const cell: HTMLTableCellElement = <HTMLTableCellElement>e.target
                    const row: HTMLTableRowElement = <HTMLTableRowElement>cell.parentElement;
                    const row2: HTMLTableRowElement = <HTMLTableRowElement>row.parentElement;
                    const row3: HTMLTableRowElement = <HTMLTableRowElement>row2.parentElement;
                    if (draggedItemIndex >= 0) {

                    }
                    if (!draggedItemIndex) {

                    }
                    const dropIndex = this.closest(row, this.tableRow).rowIndex;
                    dropItemIndex = dropIndex;
                    remoteDropItemIndex = dropIndex;
                    me.rowLine = dropIndex;

                    if (draggedItemIndex >= -1 && this.gridData.length + 1 >= draggedItemIndex) {
                        e.preventDefault();
                        const dataItem = this.gridData[draggedItemIndex];
                     //   dataItem.dragging = false;

                    }
                }));

                sub.add(dragEnd.pipe(takeUntil(this.destroy$)).subscribe((e: any) => {

                    if (typeof dropItemIndex != 'undefined') {

                        e.preventDefault();
                        const dataItem = this.gridData.splice(draggedItemIndex, 1)[0];
                        this.zone.run(() =>
                            this.gridData.splice(dropItemIndex, 0, dataItem)
                        );
                        draggedItemIndex = -1;

                        this.dataStateChange(null);
                        this.redoSortOrder();
                    }
                    const cell: HTMLTableCellElement = <HTMLTableCellElement>e.target
                    const row: HTMLTableRowElement = <HTMLTableRowElement>cell.parentElement;
                    const row2: HTMLTableRowElement = <HTMLTableRowElement>row.parentElement;
                    const row3: HTMLTableRowElement = <HTMLTableRowElement>row2.parentElement;
                }));
            }
        });

        return sub;
    }
    //popupDispatch() {

    //    this.showDispatch.emit(null);
    //}
    insertRow() {
        if (this.insertMode) return false;
        if (this.rowLine >= 0) {
            this.insertMode = true;
            var inrow = new v_InvoiceNoteBus();
            this.zone.run(() => {
                this.gridData.splice(this.rowLine, 0, inrow);
                this.insertMode = false;
            }

            );

            if (this.grid && this.grid.pageSize && this.hasGridData) {
                this.grid.data = {
                    data: this.gridData.slice(this.grid.skip, this.grid.skip + this.grid.pageSize),
                    total: this.gridData.length
                };
            }
            this.cd.detectChanges();
           // this.gridData.splice(this.rowLine, 0, inrow);
            //   this.rowLine = null;
            //this.dataStateChange(null);
            //this.redoSortOrder();
            //this.redoSortOrder();
        }

        return true;

    }
    redoSortOrder() {
        let sort: number = 1;
        this.zone.run(() => {
            for (let e of this.gridData) {
                e.sortOrder = sort++;
                e.isUpdated = true;
            }
        });
        //    this.sendParentMessage(MessageType.changed);
    }
    updateRow(dataItem: v_InvoiceNoteBus) {

        if (this.rowLine >= 0) {
            var inrow = new v_InvoiceNoteBus(dataItem);
            inrow.isDraged = true;
            this.zone.run(() => {
                this.gridData.splice(this.rowLine, 1, inrow);
            }
            );
            this.gridData.splice(this.rowLine, 1, inrow);
            this.rowLine = null;
            this.dataStateChange(null);
            this.redoSortOrder();
            if (this.grid && this.grid.pageSize && this.hasGridData) {
                this.grid.data = {
                    data: this.gridData.slice(this.grid.skip, this.grid.skip + this.grid.pageSize),
                    total: this.gridData.length
                };
            }
            this.cd.detectChanges();
            //this.redoSortOrder();
        }
    }
    public canDrop() {

        if (this.rowLine) { return true }
        if (this.rowLine == 0) { return true }
        return false;

    }
    dataStateChange(e: any): void {
        this.getDragReady();

    }

}

